import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/ilustration-sent.svg'
import _imports_2 from '@/assets/ilustration-forgot.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col mt-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-1/2"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col mt-8"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "New password", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, " Your new password must be different from one you have used before. ", -1)
const _hoisted_10 = { class: "flex flex-col mt-4" }
const _hoisted_11 = { class: "flex flex-col mt-4" }
const _hoisted_12 = { class: "flex pt-10" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "relative flex flex-row items-center justify-center" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col mt-8"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Password succesfully changed!", -1)
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col mt-8"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-1/2"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "No token found")
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.token)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("form", null, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_TextField, {
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                          typeInput: "password",
                          name: "password",
                          label: "New password",
                          error: _ctx.fieldErrors.password
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_TextField, {
                          modelValue: _ctx.password_confirmation,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password_confirmation) = $event)),
                          typeInput: "password",
                          name: "password_confirmation",
                          label: "Confirm new password",
                          error: _ctx.fieldErrors.password_confirmation
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                          disabled: _ctx.loading,
                          class: _normalizeClass(["w-full mt-4 disble:cursor-not-allowed", _ctx.loading ? 'btn-filled-lg-loading' : 'btn-filled-lg'])
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.loading)
                              ? (_openBlock(), _createBlock(_component_Spinner, {
                                  key: 0,
                                  color: "white",
                                  height: "6",
                                  width: "6",
                                  border: "2",
                                  top: "6"
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.loading ? 'ml-4' : '')
                            }, " Save new password", 2)
                          ])
                        ], 10, _hoisted_13)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/login'))),
                      class: "text-primary mt-8"
                    }, " Log In ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
      ])
    ])
  ]))
}